import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { initialCategoryState } from "./category.types";
import { categoryActions } from ".";
import {
  CLEAR_CATGEORY_STATE,
  FETCH_CATEGORY_LIST_FAILED,
  FETCH_CATEGORY_LIST_PROGRESS,
  FETCH_CATEGORY_LIST_SUCCESS,
} from "./categoryActions";

export const categoryReducer = (
  state: IStoreState["category"] = initialCategoryState,
  action: categoryActions
) => {
  switch (action.type) {
    case FETCH_CATEGORY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.InProgress;
        draftState.list = [];
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_SUCCESS: {
      const { data, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Loaded;
        draftState.list = data;
        draftState.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_CATEGORY_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.loading = LoadState.Failed;
        draftState.list = [];
      });
      return newState;
    }
    case CLEAR_CATGEORY_STATE: {
      return initialCategoryState;
    }
    default:
      return state;
  }
};
